<template>
	<JBox class="s-w-full s-bg-gray-100 s-min-h-screen">
		<!-- Max width wrapper -->
		<JBox class="s-p-4 s-max-w-6xl s-m-auto s-mt-4">
			<!-- Headline -->
			<JFlex class="s-w-full s-items-center s-mb-4 ">
				<JBox class="s-w-1/2">
					<JHeadline class="s-text-2xl">Apps</JHeadline>
				</JBox>
				<JFlex class="s-w-1/2  s-justify-end s-items-center">
					<JSpinner variant="indigo" type="dots" :delay="0" v-if="isLoading" class="s-mr-2" />
				</JFlex>
			</JFlex>

			<!-- When there are some products -->
			<template>
				<!-- Products -->
				<CTable :header="[{ label: 'Name' }, { label: 'ID' }]" :list="list">
					<template v-slot="{ item }">
						<CTableRow>
							<CTableCell>
								<RouterLink :to="{ name: 'ViewAppsDetail', params: { appId: item.appId } }" class="s-text-indigo-600">
									{{ item.appName || "---" }}
								</RouterLink>
							</CTableCell>
							<CTableCell>
								<!-- REFACTOR:THEME should be JTag variant -->
								<span class="s-bg-gray-100 s-p-1 s-rounded s-shadow s-text-xs">{{ item.appId }}</span>
							</CTableCell>
						</CTableRow>
					</template>
				</CTable>

				<JFlex class="s-h-12 s-w-full s-px-4 s-my-4  s-justify-center s-items-center">
					<!-- Loading -->
					<JBox v-if="isLoading">
						<JSpinner variant="indigo" type="dots" :delay="0" />
					</JBox>
				</JFlex>
			</template>

			<!-- Create Modal -->
			<Portal to="layer0">
				<CModal :isVisible="showCreateApp" @overlay:click="showCreateApp = false">
					<AppCreate @created="onAppCreated" />
				</CModal>
			</Portal>
		</JBox>
	</JBox>
</template>

<script>
import AppCreate from "../components/AppCreate"

export default {
	components: { AppCreate },
	data() {
		return {
			isLoading: false,
			// Create app
			showCreateApp: false
		}
	},

	computed: {
		list() {
			return this.$store?.state?.apps?.list ?? []
		}
	},

	methods: {
		async fetchApps() {
			this.isLoading = true
			const { res, isSuccess } = await this.$store.dispatch("apps/readApps")
			// TODO: handle errors when isSuccess is false
			console.log({ res, isSuccess })
			this.isLoading = false
		},

		onAppCreated({ appId }) {
			this.showCreateApp = false
			this.$router.push({ name: "ViewAppsDetail", params: { appId } })
		}
	},

	created() {
		this.fetchApps()
	}
}
</script>
